module.exports = __webpack_public_path__ + "static/media/blank-profile-picture-973460_960_720.7d5cdd28.png";